import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText } from '@material-ui/core';
import { Link } from 'react-router-dom';



const ListText = function ( props ) {
	const output = (
		<ListItemText
			primary={props.category}
			secondary={props.text}
			onClick={props.handleClose}
		/>
	);

	if ( props.link ) {
		return (
			<ListTextLink link={props.link}>
				{output}
			</ListTextLink>
		);
	}

	return output;
};


const ListTextLink = function ( props ) {
	return (
		<Link to={props.link}>
			{props.children}
		</Link>
	);
};



class NotifyItem extends React.PureComponent {

	render() {

		return (
			<ListItem button>
				<ListText
					category={this.props.category}
					text={this.props.text}
					link={this.props.link}
					handleClose={this.props.handleClose}
				/>
			</ListItem>
		);
	}
}



NotifyItem.propTypes = {
	category: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	//notificationID: PropTypes.number.isRequired,
};

export default NotifyItem;